import { render, staticRenderFns } from "./Page-Checks.vue?vue&type=template&id=68226536"
import script from "./Page-Checks.vue?vue&type=script&lang=js"
export * from "./Page-Checks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports